import * as React from 'react';
import ExerciseCard from '../../components/ExerciseCard/ExerciseCard';

export interface IDomainExerciseCardProps {
  exerciseId: string;
  workoutId: number;
  locked: boolean;
  comparison: number | null;
}

export const EvaluationExerciseCard: React.FC<IDomainExerciseCardProps> = ({
  exerciseId,
  workoutId = 0,
  locked,
  comparison,
}) => {
  const cardProps = {
    exerciseId,
    comparison,
    locked,
    workoutId,
    className: 'evaluation-exercise-card col-6',
    id: `evaluation-${exerciseId}-${workoutId}`,
  };
  return <ExerciseCard {...cardProps} />;
};

export default EvaluationExerciseCard;
